// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it
import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import meta from './data/meta.json';
import Zion from './utils/Zion';


// styles
import './styles/index.scss';
import './styles/graphic.scss';

console.log('index.js is loaded');

const pkg = require('../package.json');

let ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

// console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // console.log('pymChild:', pymChild);

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

function draw() {
  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html during development mode.
    const figure = document.querySelector('#ai2html-graphic');
    figure.innerHTML = ai2html;
    // If you want to write code for this graphic,
    // move this stuff outside the if block that it's in.
  }
}

const trk = document.querySelectorAll('[data-name="circle-group"],[data-name="totals-group"],.g-text');


window.pymChild.onMessage('viewport-iframe-position', (parentInfo) => {
  const positions = parentInfo.split(' ').map(pos => parseFloat(pos));
  console.log(positions);

  trk.forEach((trkOb) => {
    const tp = trkOb.getBoundingClientRect().top;
    if (tp > 0) {
      const tpos = 1 - ((tp + positions[2]) / positions[1]);

      // Apply the 'inview' class for all elements as soon as they appear
      trkOb.classList.toggle('inview', tpos > 0);
    }
  });
});

window.addEventListener('scroll', () => {
  window.pymChild.getParentPositionInfo(); // Request updated position
  console.log('Scroll event fired in iframe, requesting position update...');
});

setInterval(() => {
  window.pymChild.getParentPositionInfo();
}, 200);

// function rAf() {
//   window.pymChild.getParentPositionInfo();
//   requestAnimationFrame(rAf);
// }
// rAf();
